var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "rootTag",
      class: _vm.getClasses(),
      attrs: { tabindex: "-1" },
      on: {
        click: _vm.showField,
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          $event.stopPropagation()
          return _vm.onKeyUp.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "refPublishDatepickerWrapper",
          staticClass: "field-wrap field-wrap-datepicker exclude-outside-click",
          attrs: { tabindex: "0" },
          on: {
            click: function($event) {
              return _vm.findPosition()
            },
            keyup: _vm.onWrapperKeyUp
          }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                }
              ],
              staticClass: "exclude-outside-click field-value text-hover-bg"
            },
            [
              _vm.deliverable.publish_date
                ? _c("span", {
                    staticClass: "exclude-outside-click",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.formatDate(_vm.deliverable.publish_date)
                      )
                    }
                  })
                : _c("span", { staticClass: "not-set exclude-outside-click" }, [
                    _vm._v("No Date")
                  ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editing,
                  expression: "editing"
                },
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                }
              ],
              staticClass: "custom-field date-pick-field",
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  return _vm.onKeyUp.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "DatePicker",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  ref: "customDatepicker",
                  attrs: {
                    placeholder: "No Date",
                    inline: true,
                    disabled: _vm.inputsDisabled,
                    "calendar-class": "test-date-calendar",
                    tabindex: "0",
                    autofocus: true
                  },
                  on: {
                    input: _vm.dateInput,
                    changedMonth: _vm.calendarChangedMonth,
                    closed: function($event) {
                      _vm.editing = false
                    }
                  },
                  model: {
                    value: _vm.postDate,
                    callback: function($$v) {
                      _vm.postDate = $$v
                    },
                    expression: "postDate"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "calender-header",
                      attrs: { slot: "beforeCalendarHeader" },
                      slot: "beforeCalendarHeader"
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "remove-dl-btn",
                          attrs: { variant: "text" },
                          on: { click: _vm.resetDeadline }
                        },
                        [_vm._v("Remove Deadline")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "today-btn",
                          attrs: { variant: "text" },
                          on: { click: _vm.onToday }
                        },
                        [_vm._v("Today")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "calender-footer",
                      attrs: { slot: "calendarFooter" },
                      slot: "calendarFooter"
                    },
                    [
                      _c("div", { staticClass: "time-wrapper" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.postTime,
                              expression: "postTime"
                            }
                          ],
                          ref: "refTime",
                          attrs: {
                            type: "time",
                            id: _vm.timePickerId,
                            name: "appt",
                            disabled: _vm.inputsDisabled,
                            tabindex: "1"
                          },
                          domProps: { value: _vm.postTime },
                          on: {
                            blur: _vm.timeUpdated,
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "escape",
                                  undefined,
                                  $event.key,
                                  undefined
                                )
                              ) {
                                return null
                              }
                              $event.stopPropagation()
                              return _vm.onKeyUp.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.postTime = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "today-btn",
                          attrs: { variant: "text", tabindex: "2" },
                          on: { click: _vm.onDone }
                        },
                        [_vm._v("Done")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }